import {
  Plausible,
  enableAutoPageviews,
  enableAutoOutboundTracking,
} from "plausible-client";

const isLocalhost =
  /^localhost$|^127(?:\.[0-9]+){0,2}\.[0-9]+$|^(?:0*:)*?:?0*1$/.test(
    location.hostname,
  ) || location.protocol === "file:";

let shouldIgnore = false;
try {
  if (window.localStorage.plausible_ignore === "true") {
    shouldIgnore = true;
    console.warn(
      '[Plausible] Ignoring event because "plausible_ignore" is set to "true" in localStorage',
    );
  }
} catch {
  // Silently ignore errors
}

if (!isLocalhost && !shouldIgnore) {
  const plausible = new Plausible({
    domain: "ledermann.dev",
    apiHost: "https://p.ledermann.dev",
  });

  enableAutoPageviews(plausible);
  enableAutoOutboundTracking(plausible);
}
